SmTextField = require './sm-text-field'

App.SmMaskedInputComponent = SmTextField.extend
  mask: null

  completeHandler: ->
    return if @get('isDestroyed')
    Em.run.next =>
      value = @$().val()
      @sendAction 'onComplete', value

  installMaskHandler: (->
    mask = @get('mask')

    if mask
      @$().inputmask(mask, oncomplete: @completeHandler.bind(@))
  ).on('didInsertElement')